import apiEndPoints from "../../../routeConfig";
import { ApiService } from "../../../../service/api.service";

const apiService = new ApiService();

export const subscriptionCreateOrUpdate = async (data, editMode, id,) => {
  let url
  let result
  if (editMode === true) {
    url = `${apiEndPoints.subscriptionCreateOrUpdate}/subscriptionPlan/${id}`
  } else {
    url = `${apiEndPoints.subscriptionCreateOrUpdate}/subscriptionPlan`
  }
  if (editMode === true) {
    await apiService.update(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  } else {
    await apiService.post(url, data).then(response => {
      result = response;
    }).catch(error => {
      result = error;
    })
  }
  return result;
}

export const getAllSubscription = async (page = 0, limit = 10) => {
  try {
    const response = await apiService.get(`${apiEndPoints.getAllSubscription}/subscriptionPlan?page=${page + 1}&limit=${limit}`,);
    return response.data;
  } catch (error) {
    return error;
  }
};

export const subscriptionGetById = async (id) => {
  let result;
  await apiService.get(`${apiEndPoints.subscriptionGetById}/subscriptionPlan/${id}`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};

export const deleteSubscription = async (id) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.deleteSubscription}/subscriptionPlan/${id}/status/DELETED`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const subscriptionPatchApi = async (id, statusUpdate) => {
  try {
    const response = await apiService.patch(`${apiEndPoints.subscriptionPatchApi}/subscriptionPlan/${id}/status/${statusUpdate}`, '');
    return response;
  } catch (error) {
    return error;
  }
};

export const subscriptionMetaData = async () => {
  let result;
  await apiService.get(`${apiEndPoints.subscriptionMetaData}/subscriptionPlan/metadata`)
    .then((response) => {
      result = response.data;
    })
    .catch(error => {
      result = error;
    });
  return result;
};